import { Breadcrumbs } from "@mantine/core";
import { Dot } from "lucide-react";

export default {
  Breadcrumbs: Breadcrumbs.extend({
    defaultProps: {
      separator: (
        <Dot color="var(--mantine-color-dimmed)" opacity={0.4} size="0.5rem" />
      ),
    },
  }),
};
